import { createRouter, createWebHistory } from 'vue-router'
import Store from '../store';

import Login from '@View/Login';
import Dashboard from '@View/Dashboard/Dashboard';
import MyFiles from '@View/MyFiles/MyFiles';
import PlanUpgrade from '@View/PlanUpgrade';
import Sharing from '@View/WebPages/Sharing';
import UploadLinks from '@View/WebPages/UploadLinks';
import News from '@View/Roadmap/News';
import Suggestions from '@View/Roadmap/Suggestions';

import PorfileUser from '@View/Profile/ProfileUser';
import ShareDocument from '@View/WebPages/PublicAccess/ShareDocument';
import UploadThirdParty from '@View/WebPages/PublicAccess/UploadThirdParty';
import Checkout from '@View/Checkout';

import AutomationEmails from '@View/Automation/AutomationEmails';
import ExpirationAlerts from '@View/Notifications/ExpirationAlerts';


const routes = [
    {
        path: '/share/:nameCompany/:nameDocuments',
        name: 'ShareDocument',
        component: ShareDocument
    },
    {
        path: '/upload/:nameCompany/:nameDocuments',
        name: 'UploadThirdParty',
        component: UploadThirdParty
    },
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        children: [
            {
                path: '/my-files',
                name: 'MyFiles',
                component: MyFiles
            },
            {
                path: '/files',
                component: {
                    template: `<div>
                        <router-view></router-view>
                    </div>`
                },
                children: [
                    {
                        path: 'list',
                        name: 'FilesList',
                        component: MyFiles
                    },
                    {
                        path: 'add',
                        name: 'FilesAdd',
                        component: PlanUpgrade
                    }
                ]
            },
            {
                path: '/alerts',
                name: 'Alerts',
                component: PlanUpgrade
            },
            {
                path: '/web-pages',
                component: {
                    template: `<div>
                        <router-view></router-view>
                    </div>`
                },
                children: [
                    {
                        path: 'sharing',
                        name: 'WebPagesSharing',
                        component: Sharing
                    },
                    {
                        path: 'upload',
                        name: 'WebPagesUpload',
                        component: UploadLinks
                    }
                ]
            },
            {
                path: '/reports',
                name: 'Reports',
                component: PlanUpgrade
            },
            {
                path: '/automation',
                component: {
                    template: `<div>
                        <router-view></router-view>
                    </div>`
                },
                children: [
                    {
                        path: 'emails',
                        name: 'AutomationEmails',
                        component: AutomationEmails
                    }
                ]
            },
            {
                path: '/notifications',
                component: {
                    template: `<div>
                        <router-view></router-view>
                    </div>`
                },
                children: [
                    {
                        path: 'expiration-alerts',
                        name: 'ExpirationAlerts',
                        component: ExpirationAlerts
                    }
                ]
            },
            {
                path: '/news',
                name: 'News',
                component: News
            },
            {
                path: '/suggestions',
                name: 'Suggestions',
                component: Suggestions
            },
            {
                path: '/upgrade',
                name: 'PlanUpgrade',
                component: PlanUpgrade
            },
            {
                path: '/checkout/:slug',
                name: 'Checkout',
                component: Checkout
            },
            {
                path: '/profile',
                component: {
                    template: `<div>
                        <router-view></router-view>
                    </div>`
                },
                children: [
                    {
                        path: 'user',
                        name: 'ProfileUser',
                        component: PorfileUser
                    }
                ]
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/dashboard'
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// Mapeamento de títulos dinâmicos para cada rota
const pageTitles = {
    'Login': 'Login',
    'Dashboard': 'Dashboard',
    'MyFiles': 'Meus Arquivos',
    'FilesList': 'Lista de Arquivos',
    'FilesAdd': 'Adicionar Arquivos',
    'Sharing': 'Compartilhamento',
    'Alerts': 'Alertas',
    'WebPagesSharing': 'Páginas de Compartilhamento',
    'WebPagesUpload': 'Links de Upload',
    'Reports': 'Relatórios',
    'News': 'Novidades',
    'Suggestions': 'Sugestões',
    'PlanUpgrade': 'Upgrade de Plano',
    'Checkout': 'Checkout',
    'AutomationEmails': 'Envios Automatizados',
    'ExpirationAlerts': 'Alertas de Vencimento',
    'ProfileUser': 'Perfil do Usuário',
    'ShareDocument': 'Compartilhar Documento',
    'UploadThirdParty': 'Upload de Terceiros'
};

/**
 * Atualizar título da página dinamicamente
 */
const updatePageTitle = (routeName) => {
    const pageTitle = pageTitles[routeName];
    if (pageTitle) {
        document.title = `filesave - ${pageTitle}`;
    } else {
        document.title = 'filesave';
    }
};

/**
 * Criar autentição do usuario
 */
router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');
    let bodyDashboard = document.querySelector('body');

    // Rotas públicas que não precisam de autenticação
    const publicRoutes = ['ShareDocument', 'UploadThirdParty'];

    // Atualizar título da página
    updatePageTitle(to.name);

    Store.commit('changeMenu', to.name);

    if(to.path == '/' && token){
        bodyDashboard.classList.add('bodyDashboard');
        return next({name: 'Dashboard'});
    }

    if(from.path == '/' && token){
        bodyDashboard.classList.add('bodyDashboard');
        return next();
    }

    // Permitir acesso às rotas públicas sem token
    if(publicRoutes.includes(to.name)){
        bodyDashboard.classList.remove('bodyDashboard');
        return next();
    }

    if(to.path != '/' && !token){
        bodyDashboard.classList.remove('bodyDashboard');
        return next({name: 'Login'});
    }

    return next();
})

export default router
